import React from "react";
import "../css/ImpersonationBanner.css";

function ImpersonationBanner({ impersonatedUsername, adminUsername, onStop }) {
  if (!impersonatedUsername) {
    return null;
  }

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner__content">
        <div>
          <strong>Impersonating:</strong> {impersonatedUsername}
          {adminUsername && (
            <span className="impersonation-banner__subtitle">
              {" "}
              (initiated by {adminUsername})
            </span>
          )}
        </div>
        <button className="impersonation-banner__stop" type="button" onClick={onStop}>
          Stop Impersonation
        </button>
      </div>
    </div>
  );
}

export default ImpersonationBanner;

